var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"chapter-title"},[_vm._v(_vm._s(_vm.chapterInfo.title))]),_vm._v(" "),_c('div',{staticClass:"chapter-content",domProps:{"innerHTML":_vm._s(_vm.chapterInfo.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-507e6a78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layer2/book/novel-content.vue
// module id = null
// module chunks = 